/* RESPONSIBLE TEAM: team-phone */
import HoldAndAssignSerializer from '../step';

export default HoldAndAssignSerializer;
